import React from "react";

const Footer = () => {
  return (
    <footer style={{ padding: "0px 10px", textAlign: "center" }}>
      <p className="footer-text">
        Copyright © 2026-2030, Powered By{" "}
        <a href="https://growbizint.com">growbizint.com</a>{" "}
      </p>
    </footer>
  );
};

export default Footer;
